<template>
  <base-nav
    class="navbar-top navbar-dark"
    id="navbar-main"
    :show-toggle-button="false"
    expand
  >
    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center" slot="title">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="user logo" src="/img/pages/default_user.png" />
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{
                name ? name.split(" ")[0] : ""
              }}</span>
            </div>
          </div>

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Ações</h6>
            </div>
            <router-link
              :to="getFullPathBasedOnRole('configuracoes')"
              class="dropdown-item"
            >
              <i class="ni ni-single-02"></i>
              <span>Meu perfil</span>
            </router-link>
            <router-link
              :to="getFullPathBasedOnRole('suporte', 'mensagens')"
              class="dropdown-item"
            >
              <i class="ni ni-support-16"></i>
              <span>Suporte</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <a @click="handleLogout" class="dropdown-item">
              <i class="ni ni-user-run"></i>
              <span>Sair</span>
            </a>
          </template>
        </base-dropdown>
      </li>
    </ul>
  </base-nav>
</template>
<script>
import { logout, getRoles } from "../services/auth";

export default {
  props: {
    name: String,
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
    };
  },
  methods: {
    getFullPathBasedOnRole(subpath, adminSubpath) {
      const roles = getRoles();
      if (roles) {
        const role = JSON.parse(roles)[0];
        if (role === "investor") return `/investidor/${subpath}`;
        else if (role === "administrator")
          return `/admin/${adminSubpath || subpath}`;
        else return `/${role}/${subpath}`;
      }
      return "/";
    },
    handleLogout() {
      logout();
      this.$toasted.show("Até breve! :)");
      this.$router.push("/");
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
  },
};
</script>
<style>
.btn-toggle {
  position: absolute;
  z-index: 999;
  color: #ffffff;
  margin-left: 10px;
  margin-top: 29px;
  font-size: 20px;
  cursor: pointer;
}
.btn-toggle:hover,
.btn-toggle:active,
.btn-toggle:focus {
  -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1),
    0 3px 6px rgba(0, 0, 0, 0.08);
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
  -webkit-transform: translateY(-1px);
  transform: translateY(-1px);
}
</style>
